export namespace Patchnotes {
  export enum Pages {
    PATCHNOTES = 'patchnotes',
    PATCH_NOTES = 'patch_notes',
  }

  export type PatchNote = {
    id: number;
    type: {
      id: number;
      name: string;
      slug: string;
    };
    version: string;
    title: string;
    published_at: string;
    detail_text: string;
  }
}
